/**
 * Common pagination constants used across the application
 */

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;

/**
 * Standard page size options for DataTable components
 * Features can override these with custom values if needed
 */
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
